import React, { useEffect, useState } from 'react'

const AppContext = React.createContext()

function AppProvider({ children }) {
    const [openTimerModal, setOpenTimerModal] = useState(false);
    const [timerName, setTimerName] = useState('');
    const [totalPomodoros, setTotalPomodoros] = useState(0);
    const [timerKey, setTimerKey] = useState('');

    useEffect(()=>{
        const app = document.getElementById('root')
        const body = document.querySelector('body')
        if(openTimerModal===true){
            window.scrollTo(0, 0)
            app.style.display = "none"
            body.style.overflowY = "hidden"
        }else{
            app.style.display = "block"
            body.style.overflowY = "auto"
        }
    },[openTimerModal])
    return (
        <AppContext.Provider value={{
            openTimerModal,
            setOpenTimerModal,
            timerName,
            setTimerName,
            totalPomodoros,
            setTotalPomodoros,
            timerKey,
            setTimerKey
        }}>
            {children}
        </AppContext.Provider>
    )
}

export { AppContext, AppProvider }